/* AGE GATE — interaction only. The synchronous class toggle lives inline in
   <head> (snippets/age-gate-script.liquid) so it beats first paint. */
(function () {
  'use strict';
  var KEY = 'tnp_age_ok';
  var root = document.documentElement;

  function accept() {
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* session-only */ }
    root.classList.remove('age-unverified');
    document.dispatchEvent(new CustomEvent('tnp:age-accepted'));
  }

  function decline() {
    // Do NOT simply hide the gate. Send them away from the catalogue.
    window.location.href = 'https://www.google.com';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var gate = document.querySelector('[data-age-gate]');
    if (!gate) return;
    var yes = gate.querySelector('[data-age-accept]');
    var no  = gate.querySelector('[data-age-decline]');
    if (yes) yes.addEventListener('click', accept);
    if (no)  no.addEventListener('click', decline);

    // Trap focus while the gate is up — a keyboard user must not tab behind it.
    gate.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !root.classList.contains('age-unverified')) return;
      var f = gate.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (root.classList.contains('age-unverified') && yes) yes.focus();
  });
})();
